export class NotificationsReadPostRequest {
  notificationId: string
  constructor(notificationId: string) {
    this.notificationId = notificationId
  }
}
